import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail, trackEvent } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Mail } from "lucide-react";

export function Newsletter({ variant = "dark" }) {
  const { L } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const dark = variant === "dark";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email, consent: true });
      toast.success(data.message || "Subscribed successfully.");
      trackEvent("newsletter_signup");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Subscription failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={dark ? "rounded-2xl bg-navy2 p-8 border border-white/10" : "rounded-2xl bg-canvas p-8 border border-hair"}>
      <div className="flex items-center gap-2">
        <Mail className={`h-5 w-5 ${dark ? "text-gold" : "text-finblue"}`} />
        <h3 className={`font-heading text-xl font-semibold ${dark ? "text-white" : "text-ink"}`}>{L.newsletter.title}</h3>
      </div>
      <p className={`mt-2 text-sm ${dark ? "text-slate-300" : "text-subtle"}`}>{L.newsletter.desc}</p>
      <form onSubmit={submit} className="mt-5 flex flex-col gap-3 sm:flex-row">
        <Input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={L.newsletter.placeholder}
          className={dark ? "bg-white/5 border-white/15 text-white placeholder:text-slate-400" : "bg-white"}
          data-testid="newsletter-email-input"
        />
        <Button type="submit" disabled={loading} className="bg-finblue hover:bg-finblueDark shrink-0" data-testid="newsletter-submit">
          {loading ? "..." : L.common.subscribe}
        </Button>
      </form>
      <p className={`mt-3 text-xs ${dark ? "text-slate-400" : "text-subtle/80"}`}>{L.newsletter.consent}</p>
    </div>
  );
}
